import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { mobile, tablet } from '../utils/screenStyles'
import { Card } from './StyledCard'
import PatternBG from '../../assets/images/desktop_pattern_bg_signup.png'

const StyledCardContainer = styled(Card)`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0;
  margin: 0 auto;
  border: none;
  background-color: transparent;
  ${mobile`
    flex-direction: column;
    justify-content: flex-start;
  `}
`

export const StyledCardLeftSection = styled.div`
  background-image: url(${PatternBG});
  background-size: cover;
  min-width: 400px;
  min-height: 100%;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;
  overflow-y: auto;
  ${tablet`
    min-width: 330px;
  `}

  ${mobile`
    min-height: unset;
    height: unset;
    overflow-y: unset;
    min-width: 100%;
  `}
`

export const StyledCardRightSection = styled.div`
  background-color: ${props => props.theme.colors.white};
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  overflow-y: auto;
  box-shadow: 0px 20px 30px rgba(28, 81, 112, 0.1);

  ${mobile`
      height: unset;
      overflow-y: unset;
  `}
`

export const StyledCardPattern = ({ left, right, overrideStyles }) => (
  <StyledCardContainer style={overrideStyles}>
    <StyledCardLeftSection>{left}</StyledCardLeftSection>
    <StyledCardRightSection>{right}</StyledCardRightSection>
  </StyledCardContainer>
)

StyledCardPattern.propTypes = {
  left: PropTypes.node.isRequired,
  right: PropTypes.node.isRequired,
  overrideStyles: PropTypes.shape({})
}
